import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { PATH_TO_TITLE_MAPPING, APP_NAME } from "@/constants/constants";

const TitleUpdater: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = PATH_TO_TITLE_MAPPING[path] || APP_NAME;
    document.title = title;
  }, [location.pathname]);

  return null;
};

export default TitleUpdater;
